
const config = {
   // ztpl 
   // appUrl: '/rollzicecream-v1/V2',
   // apiUrl: "https://ztpl.net/rollz_api/api"

   // live 
    appUrl : "",
   apiUrl: "https://api.rollzfranchise.com/api"
   
}

export default config